interface ViteEnv {
  VITE_AUTH_API_URL: string;
  VITE_APP_API_URL: string;
  VITE_APP_ID: string;
}

declare global {
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  interface ImportMetaEnv extends ViteEnv {}
}

export const env: ViteEnv = {
  VITE_AUTH_API_URL: import.meta.env.VITE_AUTH_API_URL ?? "http://localhost:8787",
  // Empty default → relative /api/* served by Pages Function (prod) or Vite proxy (dev).
  VITE_APP_API_URL: import.meta.env.VITE_APP_API_URL ?? "",
  VITE_APP_ID: import.meta.env.VITE_APP_ID ?? "hello-app",
};
